<script>
import SearchForm from '@/components/views/searchForm/SearchForm.vue'
import SearchLabel from '@/components/services/ui/searchLabel.vue'
import SearchControls from '@/components/services/ui/searchControls.vue'
import infiniteScroll from '@/components/views/infiniteScroll/infiniteScroll.vue'
import { RexSelect } from '@/components/views/rexFieldsV2'
import ToursFilter from './views/Filters.vue'
import {
  toursCard,
  toursTable
} from './ui'

export default {
  name: 'search-tours',
  components: {
    SearchForm,
    SearchLabel,
    SearchControls,
    infiniteScroll,
    ToursFilter,
    toursCard,
    toursTable,
    RexSelect
  },
  metaInfo: {
    title: 'Поиск туров'
  },
  data: () => ({
    searchLabelFields: ['placeName', 'checkInDate', 'duration', 'rooms']
  }),
  computed: {
    isLoading() {
      return this.$store.getters['toursSearch/isLoading']
    },
    isLoadingMore() {
      return this.$store.getters['toursSearch/isLoadingMore']
    },
    isUpdating() {
      return this.$store.getters['toursSearch/isUpdating']
    },
    collection() {
      return this.$store.getters['toursSearch/getCollection']
    },
    filters() {
      return this.$store.getters['toursSearch/getCollectionFilters']
    },
    pagination() {
      return this.$store.getters['toursSearch/getPagination']
    },
    viewType() {
      return this.$store.getters['toursSearch/getViewType']
    },
    searchForm() {
      return this.$store.getters['toursSearch/getFormForSearch']
    },
    noResults() {
      return !this.collection.length && !(this.isLoading || this.isUpdating)
    },
    isEmptySearchResults() {
      return this.$store.getters['toursSearch/isEmptySearchResults']
    },
    isFiltersApplied() {
      return this.$store.getters['toursSearch/isFiltersApplied']
    },
    isFiltersDisabled() {
      return this.$store.getters['toursSearch/isFiltersDisabled']
    },
    showForm: {
      get() {
        return this.$store.getters['toursSearch/showForm']
      },
      set(value) {
        this.$store.commit('toursSearch/setFormShowed', value)
      }
    },
    showSearch: {
      get() {
        return this.$store.getters['toursSearch/showSearch']
      },
      set(value) {
        this.$store.commit('toursSearch/setSearchShowed', value)
      }
    },
  },
  created() {
    if (Object.keys(this.$route.query).length) {
      this.$store.commit('toursSearch/setSearchFieldsFromQueryParams', this.$route.query)
      this.$store.commit('toursSearch/setIsLoading', true)
      this.$store.commit('toursSearch/setEmptySearchResults', false)
      this.$store.dispatch('toursSearch/getCollection', {
        ...this.searchForm,
        isSearch: true
      })
    } else {
      this.showForm = true
      this.showSearch = false
    }
  },
  beforeDestroy() {
    this.$store.commit('toursSearch/setInitialState')
  },
  methods: {
    loadMore() {
      this.$store.commit('toursSearch/setIsLoadingMore', true)
      this.$store.commit('toursSearch/setIsFiltersDisabled', true)
      this.showForm = false

      this.$store.dispatch('toursSearch/getCollection', {
        ...this.searchForm,
        page: this.pagination.page + 1
      })
    },
    update() {
      this.$store.commit('toursSearch/setIsFiltersApplied', true)
      this.$store.commit('toursSearch/setIsUpdating', true)
      this.$store.commit('toursSearch/setIsFiltersDisabled', true)
      this.showForm = false

      this.$store.dispatch('toursSearch/getCollection', {
        ...this.searchForm,
        page: 1
      })
    },
    resetFilters() {
      this.$store.commit('toursSearch/clearFilters')
      this.$store.commit('toursSearch/setIsLoading', true)
      this.$store.dispatch('toursSearch/getCollection', {
        ...this.searchForm,
        isSearch: true,
        page: 1,
      })
    },
    startNewSearch() {
      this.showForm = true
      this.showSearch = false
    }
  }
}
</script>
<template>
  <div>
    <search-form
      v-show="showForm"
    />
    <div
      v-if="showSearch"
      class="search-content"
    >
      <div>
        <tours-filter
          v-if="!(noResults && isEmptySearchResults)"
          @filter="update"
          @reset="resetFilters"
        />
      </div>
      <div class="search-content__results">
        <div class="search-content__results-header">
          <search-label
            v-if="!showForm"
            :required-fields="searchLabelFields"
            service="Туры"
            @click="showForm = true"
          />
        </div>
        <div
          v-if="!noResults"
          class="search-content__results-controls-wrap"
        >
          <div class="search-content__results-controls-item">
            <rex-select
              name="toursSearchType"
              store-module="toursSearch"
              target="filters.toursTypes"
              empty-label="Тип тура"
              :options="filters.toursTypes"
              :is-multiple="true"
              :is-disabled="isLoading || isLoadingMore || isFiltersDisabled"
              :hide-if-empty="false"
              class="search-content__results-controls-select"
              @change="update"
            />
            <rex-select
              name="toursSearchTour"
              store-module="toursSearch"
              target="filters.toursNames"
              empty-label="Название тура"
              :options="filters.toursNames"
              :is-multiple="true"
              :is-disabled="isLoading || isLoadingMore || isFiltersDisabled"
              :hide-if-empty="false"
              class="search-content__results-controls-select"
              @change="update"
            />
          </div>
          <div class="search-content__results-controls-item">
            <search-controls
              store-module="toursSearch"
              getter-field-name="getField"
              setter-field-name="setField"
              :is-loading="isLoading || isLoadingMore || isFiltersDisabled"
              :is-sort-blocked="!isFiltersApplied"
              @sort="update"
              @filter="update"
            />
          </div>
        </div>
        <div
          v-if="noResults"
          class="search-content__no-results"
        >
          <h2
            v-if="isEmptySearchResults"
          >
            Ничего не найдено.<br>
            Попробуйте <span @click="startNewSearch">изменить параметры поиска.</span>
          </h2>
          <h2
            v-else
          >
            Нет подходящих результатов.<br>
            Измените фильтры или <span @click="resetFilters">сбросьте их</span>.
          </h2>
        </div>
        <infinite-scroll
          v-else
          :pagination="pagination"
          :is-loading="isLoadingMore || isLoading || isUpdating"
          :is-loading-blocked="!isFiltersApplied"
          @loadMore="loadMore"
          @filtering="update"
        >
          <tours-card
            v-if="viewType === 'card'"
            :collection="collection"
          />
          <tours-table
            v-if="viewType === 'table'"
            :collection="collection"
          />
        </infinite-scroll>
      </div>
    </div>
  </div>
</template>
